<template>
    <b-container>
        <b-row align-h="center">
            <b-col cols="12" class="pb-md-4 pt-4 pb-2">
                <b-card class="shadow">
                    <h4 class="text-center text-primary text-uppercase">
                        <u>Ticket: ID {{ details.id }}</u>
                    </h4>
                    <h5 class="text-center">Estado: {{ details.status_name }}</h5>
                </b-card>
            </b-col>
        </b-row>
        <b-row align-h="center" align-v="stretch">
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Detalles del Ticket</b-th>
                                <b-td stacked-heading="ID Pago">{{ details.payment }} <b-button variant="link" size="sm" style="line-height: 1.2" class="py-0" :to="'/admin/request/'+details.payment+'/details'" v-if="user.role === 'Administrator'">Ver</b-button></b-td>
                                <b-td stacked-heading="Nombre">{{ details.name }}</b-td>
                                <b-td stacked-heading="Email">{{ details.email }}</b-td>
                                <b-td stacked-heading="Teléfono">{{ details.phone }}</b-td>
                                <b-td stacked-heading="Motivo">{{ details.reason }}</b-td>
                                <b-td stacked-heading="Descripción">{{ details.description }}</b-td>
                                <b-td stacked-heading="Creación">{{ details.date }}</b-td>
                                <b-td stacked-heading="Actualización">{{ details.update }}</b-td>
                                <b-td stacked-heading="País">{{ details.country_name }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-card-text style="height: 400px; overflow-y: auto; overflow-x: hidden;" v-chat-scroll>
                        <template v-for="msg in messages">
                            <b-row v-if="msg.user_id === user.id" align-h="end">
                                <b-col cols="auto" class="pl-5">
                                    <b-list-group horizontal class="py-2">
                                        <b-list-group-item variant="primary" class="flex-fill align-items-start rad-right  text-right">
                                            <div class="w-100 justify-content-between border-bottom">
                                                <h6 class="mb-1">
                                                    <b-icon icon="shield-fill-check" v-if="msg.role !== 'Customer' && msg.role !== 'Partner'"></b-icon>
                                                    <span>{{msg.name}} (Tú)</span>
                                                </h6>
                                            </div>
                                            <p class="mt-2 mb-0">{{msg.message}}</p>
                                            <small>{{msg.date}}</small>
                                        </b-list-group-item>
                                        <b-list-group-item class="align-items-center px-2">
                                            <b-avatar :src="'/'+(msg.photo ? msg.photo : (msg.role === 'Customer' ? 'img/customer.png' : 'img/support.jpg'))" :alt="msg.name"></b-avatar>
                                        </b-list-group-item>
                                    </b-list-group>
                                </b-col>
                            </b-row>
                            <b-row v-else align-h="start">
                                <b-col cols="auto" class="pr-5">
                                    <b-list-group horizontal class="py-2">
                                        <b-list-group-item class="align-items-center px-2">
                                            <b-avatar :src="'/'+(msg.photo ? msg.photo : (msg.role === 'Customer' ? 'img/customer.png' : 'img/support.jpg'))" :alt="msg.name"></b-avatar>
                                        </b-list-group-item>
                                        <b-list-group-item variant="secondary" class="flex-fill align-items-start rad-left">
                                            <div class="d-flex w-100 justify-content-between border-bottom">
                                                <h6 class="my-1">
                                                    <b-icon icon="shield-fill-check" v-if="msg.role !== 'Customer' && msg.role !== 'Partner'"></b-icon>
                                                    <span>{{msg.name}}</span>
                                                </h6>
                                            </div>
                                            <p class="mt-2 mb-0">{{msg.message}}</p>
                                            <small>{{msg.date}}</small>
                                        </b-list-group-item>
                                    </b-list-group>
                                </b-col>
                            </b-row>
                        </template>
                    </b-card-text>
                    <b-card-footer class="px-3" style="height: 74px;">
                        <b-form id="formMsg" @submit.stop.prevent="send" v-if="details.status !== 303">
                            <b-row align-h="center" align-v="stretch" class="mx-0">
                                <b-col cols="10" class="px-1 text-center" align-self="start">
                                    <b-form-group>
                                        <b-form-input
                                            name="msg"
                                            type="text"
                                            v-model="form.msg"
                                            v-validate="'required:true'"
                                            :state="validateState('msg')"
                                            :data-vv-as="(labels.msg).toLowerCase()"
                                            :disabled="loading"
                                            placeholder="Escribe tu respuesta"
                                            aria-describedby="msg-live-feedback"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="msg-live-feedback">{{
                                                veeErrors.first('msg')
                                            }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="2" class="px-1 text-center" align-self="start">
                                    <b-button type="submit" variant="primary" pill class="shadow py-2" form="formMsg" :disabled="loading">
                                        <b-spinner small type="grow" v-if="loading"></b-spinner>
                                        <b-icon icon="chat-left-text-fill" aria-hidden="true" v-else></b-icon>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "TicketView",
    props: [ 'user' ],
    data: () => ({
        loading: true,
        details: {
            id: '',
            user_id: '',
            name: '',
            email: '',
            phone: '',
            payment: '',
            reason: '',
            description: '',
            status: '',
            status_name: '',
            date: '',
            update: '',
            country: '',
            country_name: ''
        },
        messages: [],
        labels: {
            msg: 'Mensaje'
        },
        form: {
            msg: ''
        }
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'ticketpage');
        this.details.id = this.$route.params.id;
        this.getIni();
    },
    methods: {
        getIni() {
            let id = this.$route.params.id;
            axios.get('/api/customer/tickets/' + id + '/details').then((res) => {
                if (res.data.status === 'success') {
                    this.details = res.data.details;
                } else {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (this.user.partner) {
                        this.$router.push({name: 'PartnerTicketView'});
                    } else {
                        this.$router.push({name: 'TicketView'});
                    }
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.getMessages();
                this.loading = false;
            });
        },
        getMessages() {
            let id = this.$route.params.id;
            axios.get('/api/customer/tickets/' + id + '/messages').then((res) => {
                if (res.data.status === 'success') {
                    this.messages = res.data.messages;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
            this.timeout = setTimeout(this.getMessages, 5000);
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        send() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;
                axios.post('/api/customer/tickets/'+this.details.id+'/messages/send', this.form).then((res) => {
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.form.msg = '';
                        this.$validator.reset();
                    } else {
                        this.$root.$bvToast.toast(res.data.msg, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: res.data.status,
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>
.list-group-item {
    border: none;
}
.rad-left {
    border-radius: 8px !important;
    border-top-left-radius: 0px !important;
}
.rad-right {
    border-radius: 8px !important;
    border-top-right-radius: 0px !important;
}
.b-avatar {
    border: 1px solid #000;
}
small, .small {
    font-size: 60%;
}
</style>
